import App from './src/components/App'
import MFADialog from './src/dialogs/MFA'
import { getMuiTheme } from './src/utils'
import PasswordManagement from './src/components/password-management'
import PasswordManagementForm from './src/components/elements/PasswordManagementForm'
import NewPasswordTextField from './src/components/elements/NewPasswordTextField'
import PasswordUpdated from './src/dialogs/PasswordUpdated'
import SecurityDialog from './src/dialogs/Index'
import { useRemindAccountSecurity } from './src/utils'

/**
 *
 */
export {
    getMuiTheme,
    MFADialog,
    NewPasswordTextField,
    PasswordManagement,
    PasswordManagementForm,
    PasswordUpdated,
    SecurityDialog,
    useRemindAccountSecurity
}

export default App
